export default __webpack_public_path__ + "static/te-cover-small-f915edc978f86ae9566e1bf474513c3a.png";